<div class="container-fluid overflow-hidden py-4">
    <div class="row mb-3">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
    <div class="row mb-3">
        <div class="col">
            <h2>Process Payment</h2>
        </div>
    </div>
    <div class="row" *ngIf="paymentType === 'card'">
        <div class="col">
            <mat-error *ngIf="selectedReader.status === 'offline'">Selected terminal reader is offline. Please choose
                cash or online to accept payments</mat-error>
            <mat-form-field style="width: 100%;">
                <mat-select placeholder="Reader" [(value)]="selectedReader">
                    @for (reader of readers; track reader) {
                    <mat-option [value]="reader">{{reader.label}}
                        @if(reader.status === 'online'){
                        <mat-icon style="color: green">wifi</mat-icon>
                        } @else {
                        <mat-icon style="color: red">wifi_off</mat-icon>
                        }
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <p>How are you paying?</p>
            <mat-radio-group aria-label="payment-type" [(ngModel)]="paymentType">
                <mat-radio-button [value]="'card'">Card</mat-radio-button>
                <mat-radio-button [value]="'cash'">Cash</mat-radio-button>
                <mat-radio-button [value]="'online'" (change)="createPaymentIntent()">Online</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="row">
            <div class="col">
                @if (elementsOptions.clientSecret && paymentType === 'online'){
                <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                    <ngx-stripe-payment [options]="paymentElementsOptions" />
                </ngx-stripe-elements>
                }
            </div>
        </div>
        <div class="row" *ngIf="isPaymentProcessing">
            <div class="col">
                <p>Payment Processing.... This may take a few seconds.</p>
            </div>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-2">
            <button mat-raised-button (click)="onPaymentSubmit()"
                [disabled]="isLoading || (selectedReader?.status === 'offline' && paymentType === 'card')">Submit</button>
        </div>
        <div class="col">
            <button mat-raised-button class="warning" (click)="dialogRef.close('cancel'); cancelPaymentIntent()"
                [disabled]="isLoading">Cancel</button>
        </div>
    </div>
</div>